import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../../pageheader/PageHeader";
import HeadBar from "../headBar/HeadBar";
import styles from "./PermissionPatient.module.css";
import Checkbox from "../../material/checkbox/Checkbox";
import Button from "../../material/button/Button";
import { HashLoader } from "react-spinners";
import * as publicApi from "../../../service/publicApi";
import moment from "moment";
import "moment/locale/th";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import { convertToYMD } from "../../utility/Helper";

function PermissionPatient() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [showCard1, setShowCard1] = useState(false);
  const [personalInformation, setPersonalInformation] = useState(false);

  const [showCard2, setShowCard2] = useState(false);
  const [consentForm, setConsentForm] = useState(false);

  const [showCard3, setShowCard3] = useState(false);
  const [everyTime, setEveryTime] = useState(false);
  const [someTime, setSomeTime] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [date, setDate] = useState("");
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
  }, []);
  useEffect(() => {
    if (personalInformation && consentForm) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [personalInformation, consentForm]);

  const backButton = () => {
    nav("/register", {
      state: location.state,
    });
  };
  const submitButton = () => {
    let data = location.state;
    // console.log(data)
    let body = {
      mohpromt_account_id: data.mohpromtId || "",
      ones_did: data.onesDid || "",
      thai_d: data.thaiD || "",
      access_token: data.access_token || "",
      pname: data.pname,
      fname: data.fname,
      lname: data.lname,
      pid: data.pid,
      gender: data.gender,
      birthday_fill: convertToYMD(data.birthday),
      // "birthday_year": data.yearOB,
      // "birthday_month": data.monthOB,
      // "birthday_day": data.dayOB,
      laser: data.laserId,
      current_address: {
        address: data.address,
        village_number: data.moo,
        alley: data.soy,
        road: data.road,
        sub_district_id: data.subDistrictId,
        post_code: data.postCode,
      },
      phone_number: data.phoneNumber,
      email: data.email,
      username: data.userName,
      password: data.password,
      confirm_password: data.confirmPassword,
      permission: {
        policy_personal_information: personalInformation,
        consent_form: consentForm,
        access_data_every_time: false,
        access_data_some_time: false,
      },
    };
    register(body);
  };

  const register = async (body) => {
    setLoading(true);
    let res = await publicApi.registerPatient(body);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
        nav("/login");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="global-page">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <HeadBar menu="register" />
      <PageHeader
        titlename="เงื่อนไขการใช้งานระบบ"
        description="นโยบายการใช้งานสำหรับประชาชนทั่วไป"
      />

      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.mainCard}>
            <Checkbox
              id="checkbox1"
              value={personalInformation}
              setValue={setPersonalInformation}
            />
            <div className={styles.text}>นโยบายคุ้มครองข้อมูลส่วนบุคคล</div>
            <img
              onClick={() => {
                setShowCard1(!showCard1);
              }}
              className={`${showCard1 ? styles.active : ""}`}
              src={require("../../../asset/icon/chevron-down.svg").default}
            ></img>
          </div>
          <div
            className={`${styles.detailCard} ${showCard1 ? styles.detailActive : ""}`}
          >
            <div>
              “ผูกพันธุ์”
              คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
              ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
              โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
              หรือแอปพลิเคชัน ผูกพันธุ์
              <div className={styles.return}></div>
              นอกจากนี้
              แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
              นำร่อง 4 การทดสอบ ได้แก่
              <div></div>- การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น
              แพ้ยาที่เกิดจากการได้รับยา Allopurinol
              <div></div>- การตรวจ HLA-B*15:02
              เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา Carbamazepine
              <div></div>- การตรวจ HLA-B*57:01
              เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา Abacavir (Abacavir
              hypersensitivity reaction)
              <div></div>- การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
              เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
              <div className={styles.return}></div>
              โรงพยาบาล/ห้องปฏิบัติการอื่นๆ
              สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
              เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
              บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
              ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
              ต่างโรงพยาบาล
              และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
              ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
              มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
              หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
              <div className={styles.return}></div>
              “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์ “ผู้ใช้บริการ”
              หมายความถึง ผู้สมัครใช้บริการระบบ
              <div className={styles.return}></div>
              <div className={styles.title}>
                ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
              </div>
              <div className={styles.return}></div>
              1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
              ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย
              ทั้งนี้ ผู้ใช้บริการสามารถ
              ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
              <div></div>
              2.
              ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
              เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
              ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน
              ไม่ถูกต้อง หรือเป็นข้อมูลเท็จ
              ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
              เลินเล่อก็ตาม
              ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
              <div></div>
              3. ในการใช้บริการบางกรณี
              ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้ e-Mail
              หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
              <div></div>
              4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
              โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
              ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
              <div></div>
              5.
              ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
              ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
              <div></div>
              6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
              โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
              หรือกระทำการอื่นใด นอกจาก
              การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
              <div></div>
              7.
              ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
              หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
              ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
              <div></div>
              8.
              ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
              รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
              ผู้ให้บริการ
              ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
              อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560
              , พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
              และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
              ความผิดทางวินัยด้วยแล้วแต่กรณี
              <div></div>
              9. การแก้ไข เปลี่ยนแปลง
              หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
              ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
              ตามความเหมาะสม กับสถานการณ์
              <div className={styles.return}></div>
              ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.mainCard}>
            <Checkbox
              id="checkbox2"
              value={consentForm}
              setValue={setConsentForm}
            />
            <div className={styles.text}>
              แบบฟอร์มยินยอมเข้าถึงข้อมูลสุขภาพและเปิดเผยข้อมูล
            </div>
            <img
              onClick={() => {
                setShowCard2(!showCard2);
              }}
              className={`${showCard2 ? styles.active : ""}`}
              src={require("../../../asset/icon/chevron-down.svg").default}
            ></img>
          </div>
          <div
            className={`${styles.detailCard} ${showCard2 ? styles.detailActive : ""}`}
          >
            <div>
              <div>
                ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ
                แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวมข้อมูลพันธุกรรม
                ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ
                และให้ผู้ใช้งานสามารถเข้าถึงผลการตรวจ ผ่านช่องทางต่าง ๆ เช่น
                เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
                ระเบียนสุขภาพอิเล็กทรอนิกส์ส่วนบุคคล (Personal Health Record:
                PHR) และระบบสารสนเทศของโรงพยาบาล (Hospital Information System:
                HIS) เป็นต้น โดยมีผู้ใช้งานระบบและบทบาทที่เกี่ยวข้อง ดังนี้
              </div>
              <div style={{ marginLeft: "20px" }}>
                1. ประชาชน
                เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
              </div>
              <div style={{ marginLeft: "20px" }}>
                2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
                ประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรคที่เฉพาะบุคคล
                ส่งเสริมการรักษา แบบการแพทย์แม่นยำ (Precision Medicine)
              </div>
              <div style={{ marginLeft: "20px" }}>
                3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ
                นักวิทยาศาสตร์การแพทย์ ลงข้อมูลผลการตรวจในระบบแพลตฟอร์มดิจิทัล
                “ผูกพันธุ์”
              </div>
              <div>
                ระบบฯ รองรับการเชื่อมต่อ PHR ต่าง ๆ
                ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น
                และการเชื่อมโยงข้อมูลกับระบบ HIS
                ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้
              </div>
              <div>
                ข้าพเจ้ายินยอมให้โรงพยาบาลและบุคลากรทางการแพทย์ที่เข้าร่วมใช้งานระบบฯ
                เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
                โดยมีวัตถุประสงค์ดังต่อไปนี้
              </div>
              <div style={{ marginLeft: "20px" }}>
                1. ให้บุคลาการทางการแพทย์ในโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ
                ผ่านระบบ HIS และบุคลาการทางการแพทย์ ที่เข้าร่วมใช้งานระบบฯ
                ที่ได้รับการยินยอมให้เข้าถึงข้อมูลพันธุกรรมของข้าพเจ้า
                สามารถเรียกดูข้อมูลพันธุกรรมอิเล็กทรอนิกส์ เพื่อ
              </div>
              <div style={{ marginLeft: "20px" }}>
                1.1 ใช้ข้อมูลประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรค
              </div>
              <div style={{ marginLeft: "20px" }}>
                1.2
                เพิ่มความสะดวกในการเข้ารับการรักษาต่างโรงพยาบาลและส่งต่อข้อมูลทางพันธุกรรมของประชาชน
              </div>
              <div style={{ marginLeft: "20px" }}>
                1.3 ลดการตรวจซ้ำซ้อน
                เนื่องจากผลการตรวจทางพันธุกรรมส่วนมากตรวจเพียงครั้งเดียวสามารถใช้ผลได้ตลอดชีวิต
                ไม่จำเป็นต้องตรวจซ้ำ
              </div>
              <div style={{ marginLeft: "20px" }}>
                1.4
                เข้าถึงข้อมูลพันธุกรรมได้ในกรณีฉุกเฉินหรือประชาชนที่กำลังหมดสติเป็นการเพิ่มโอกาสการรักษา
                แบบทันท่วงที
              </div>
              <div style={{ marginLeft: "20px" }}>
                2.
                พัฒนาประสิทธิภาพการให้บริการทางการแพทย์ของโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ
              </div>
              <div style={{ marginLeft: "20px" }}>
                3. พัฒนาประสิทธิภาพและส่งเสริมการให้บริการของระบบฯ
              </div>
              <div style={{ marginLeft: "20px" }}>
                4. การปฏิบัติตามเงื่อนไขการให้บริการของระบบฯ
              </div>
              <div style={{ marginLeft: "20px" }}>
                5. พัฒนาความปลอดภัยของเครือข่ายและข้อมูล
              </div>
              <div>
                โดยข้อมูลส่วนบุคคลของข้าพเจ้าจะไม่ถูกจัดเก็บเกินกว่าระยะเวลาที่จำเป็นต่อการดำเนินการตามวัตถุประสงค์ข้างต้น
                เว้นแต่กรณีที่กฎหมายกำหนดเท่านั้น
              </div>
              <div>
                ข้าพเจ้ายินยอมให้โรงพยาบาลที่เข้าร่วมใช้งานระบบฯ ผ่านระบบ HIS
                รับ-ส่ง เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
                เมื่อข้าพเจ้ากดยอมรับความยินยอมฉบับนี้
                จะถือว่าข้าพเจ้ายินยอมให้ทุกโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ
                ผ่านระบบ HIS ณ ปัจจุบัน รวมถึงที่จะเข้าร่วมในอนาคต สามารถรับ-ส่ง
                เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้ากับระบบฯ ดังนี้
              </div>
              <div style={{ marginLeft: "20px" }}>1. ข้อมูลส่วนตัว เช่น</div>
              <div style={{ marginLeft: "20px" }}>1.1 คำนำหน้า</div>
              <div style={{ marginLeft: "20px" }}>1.2 ชื่อ-นามสกุล</div>
              <div style={{ marginLeft: "20px" }}>
                1.3 เลขบัตรประจำตัวประชาชน
              </div>
              <div style={{ marginLeft: "20px" }}>1.4 เพศ</div>
              <div style={{ marginLeft: "20px" }}>1.5 อายุ</div>
              <div style={{ marginLeft: "20px" }}>1.6 หมายเลขโทรศัพท์</div>
              <div style={{ marginLeft: "20px" }}>
                2. ข้อมูลสุขภาพละเอียดอ่อน เช่น
              </div>
              <div style={{ marginLeft: "20px" }}>2.1 ข้อมูลพันธุกรรม</div>
              <div>
                ข้าพเจ้ายินยอมให้บุคลาการทางการแพทย์ที่เข้าร่วมใช้งานระบบฯ
                สามารถเข้าถึง ใช้งาน และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ดังนี้
              </div>
              <div style={{ marginLeft: "20px" }}>1. ข้อมูลส่วนตัว เช่น</div>
              <div style={{ marginLeft: "20px" }}>1.1 คำนำหน้า</div>
              <div style={{ marginLeft: "20px" }}>1.2 ชื่อ-นามสกุล</div>
              <div style={{ marginLeft: "20px" }}>
                1.3 เลขบัตรประจำตัวประชาชน
              </div>
              <div style={{ marginLeft: "20px" }}>1.4 เพศ</div>
              <div style={{ marginLeft: "20px" }}>1.5 อายุ</div>
              <div style={{ marginLeft: "20px" }}>1.6 หมายเลขโทรศัพท์</div>
              <div style={{ marginLeft: "20px" }}>1.7 อีเมลล์</div>
              <div style={{ marginLeft: "20px" }}>
                2. ข้อมูลสุขภาพละเอียดอ่อน เช่น
              </div>
              <div style={{ marginLeft: "20px" }}>2.1 ข้อมูลพันธุกรรม</div>
              <div>
                หากโรงพยาบาลนำข้อมูลส่วนบุคคลของข้าพเจ้าไปใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ระบุไว้ข้างต้น
                จะต้องได้รับความยินยอมจากข้าพเจ้าก่อน
                เว้นแต่เป็นการเปิดเผยตามที่กฎหมายบัญญัติหรือมีคำสั่งศาลให้เปิดเผย
              </div>
              <div>
                โดยข้าพเจ้ารับทราบว่าข้าพเจ้าสามารถเปลี่ยนแปลงหรือยกเลิกความยินยอมได้
                แต่ไม่มีผลลบล้างความยินยอม และผลแห่งความยินยอมซึ่งได้กระทำไปแล้ว
                ก่อนหน้านั้น
              </div>
              <div>
                ข้าพเจ้ายินยอมให้กรมวิทยาศาสตร์การแพทย์
                และผู้พัฒนาและดูแลระบบในฐานหน่วยงานที่ได้รับมอบหมายจากกรมวิทยาศาสตร์การแพทย์
                เก็บรวบรวม เข้าถึง ใช้งาน จัดการ
                และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
                โดยยอมรับและตกลงที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการตามรายละเอียดใน
                “ข้อกำหนดและ เงื่อนไขการใช้บริการ ผูกพันธุ์”
              </div>
              <div>
                ข้าพเจ้าได้อ่านและเข้าใจรายละเอียดการให้ความยินยอมข้างต้น
                รวมไปถึงประกาศนโยบายความเป็นส่วนตัวของประชาชน ตามรายละเอียดใน
                “นโยบายความเป็นส่วนตัวของประชาชน (Privacy Notice)”
              </div>
              <div>
                <br />
              </div>
              <div>
                หมายเหตุ: ความยินยอมฉบับนี้มีการทบทวนล่าสุดเมื่อวันที่ 10
                พฤศจิกายน 2566
              </div>
            </div>
          </div>
        </div>

        {/* <div className={styles.card}>
          <div className={styles.mainCard}>
            <div className={styles.text}>แบบฟอร์มอนุญาตให้เข้าถึงข้อมูล</div>
            <img onClick={() => { setShowCard3(!showCard3) }} className={`${showCard3 ? styles.active : ''}`} src={require('../../../asset/icon/chevron-down.svg').default}></img>
          </div>
          <div className={`${styles.detailCard} ${showCard3 ? styles.detailActive : ''}`}>
            <div>เพื่อผลประโยชน์ของท่าน ท่านจะยินยอมให้แพทย์เข้าถึงข้อมูลผลตรวจของท่านโดย</div>
            <div className={styles.detailContainer}>
              <Checkbox id={"checkbox3"} value={everyTime} setValue={(e) => {
                if (e) {
                  setEveryTime(true)
                  setSomeTime(false)
                } else {
                  setEveryTime(false)
                }
              }} />
              <div className={styles.text}>ข้าพเจ้ายินยอมให้แพทย์และเภสัชกรเข้าถึงข้อมูลผลตรวจได้ตลอดเพื่อเป็นประโยชน์ต่อข้าพเจ้าในการป้องกันและรักษาโรค จนกว่าข้าพเจ้าจะยกเลิกการอนุญาต</div>
            </div>
            <div className={styles.detailContainer}>
              <Checkbox id={"checkbox4"} value={someTime} setValue={(e) => {
                if (e) {
                  setSomeTime(true)
                  setEveryTime(false)
                } else {
                  setSomeTime(false)
                }
              }} />
              <div className={styles.text}>ข้าพเจ้าจะอนุญาตให้แพทย์และเภสัชกรเข้าถึงข้อมูลของข้าพเจ้าเป็นครั้ง ๆ โดยแต่ละครั้งต้องได้รับการอนุญาตจากข้าพเจ้า</div>
            </div>
          </div>
        </div> */}

        <div className={styles.buttonContainer}>
          <Button
            style={{ width: 120, background: "#FFFFFF", color: "#000" }}
            onClick={backButton}
          >
            ย้อนกลับ
          </Button>
          <Button
            disabled={disabledButton || loading}
            style={{ width: 120 }}
            onClick={submitButton}
          >
            ยอมรับ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PermissionPatient;
